import React, { useState } from "react";

import { Collapse, Tag } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import OverviewTree from "./OverviewTree";
import OverviewStats from "./OverviewStats";
import Overview1 from "./Overview1";
import PlanCollapse from "./PlanCollapse";
import Overview2 from "./Overview2";
import Overview3 from "./Overview3";

const { Panel } = Collapse;

function Overview() {
  const [plan, setPlan] = useState("Org");

  return (
    <div className="pb-8">
      <div className="text-base mb-3 text-center">
        This performance cycle ends on June 2022
      </div>
      <OverviewStats plan={plan} setPlan={(p) => setPlan(p)} />

      <div className="text-base pri-font mb-3">{plan + " plans progress"}</div>
      {plan === "Your" && <Overview1 />}
      {plan === "Unit" && <Overview2 />}
      {plan === "Org" && <Overview3 />}

      <div className="text-base pri-font mb-3 mt-6">{plan + " plans"}</div>
      <PlanCollapse />
    </div>
  );
}

export default Overview;
